<template>
  <a-card :bordered="false">
    <!-- <div class="v-between" style="margin-bottom:12px">
      <a-button type="primary">新增同级</a-button>
      <a-button type="primary">新增下级</a-button>
      <a-button type="primary">编辑</a-button>
      <a-button>删除</a-button>
    </div> -->
    <a-input-search
      style="margin:16px 0"
      placeholder="搜索"
      @change="deptSearch"
    ></a-input-search>
    <a-tree
      :expandedKeys="expandedKeys"
      :selectedKeys="selectedKeys"
      :autoExpandParent="autoExpandParent"
      :treeData="treeData"
      @expand="onExpand"
      @select="onSelect"
    >
      <template slot="title" slot-scope="{ title }">
        <span v-if="title.indexOf(searchValue) > -1">
          {{ title.substr(0, title.indexOf(searchValue)) }}
          <span style="color: #f50">{{ searchValue }}</span>
          {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
        </span>
        <span v-else>{{ title }}</span>
      </template>
    </a-tree>
  </a-card>
</template>

<script>
import { findAllDepts } from "@/api/system/dept";

export default {
  name: "DeptTree",
  data() {
    return {
      expandedKeys: [],
      selectedKeys: [],
      searchValue: "",
      autoExpandParent: true,
      treeData: [],
      dataList: []
    };
  },
  created() {
    this.initTree();
  },
  methods: {
    initTree() {
      findAllDepts()
        .then(res => {
          if (res.resultCode === 1) {
            this.generateData(res.result);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    generateData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].scopedSlots = { title: "title" };
        if (data[i].children) {
          this.generateData(data[i].children);
        }
      }
      this.treeData = data;
      this.generateList(this.treeData);
    },
    generateList(data) {
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const key = node.key;
        const title = node.title;
        this.dataList.push({ key, title: title });
        if (node.children) {
          this.generateList(node.children);
        }
      }
    },
    getParentKey(key, tree) {
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key;
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSelect(key, e) {
      let record = e.node.dataRef;
      // tree选择的keys
      this.selectedKeys = [record.key];
      this.$emit("select", record);
    },
    onClearSelected() {
      this.tempSelected = {};
      this.selectedKeys = [];
    },
    deptSearch(e) {
      const value = e.target.value;
      const expandedKeys = this.dataList
        .map(item => {
          if (item.title.indexOf(value) > -1) {
            return this.getParentKey(item.key, this.treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    }
  }
};
</script>

<style>
.v-between {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
